// React
import React from "react";
import PropTypes from "prop-types";
// Framework
import { makeStyles, Grid } from "@material-ui/core";
import { classnames } from "ui/classnames";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  disableGutter: {
    padding: `0px !important`,
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const Spacer = ({ disableGutter, children }) => {
  // Styles
  const classes = useStyles();
  // Render
  return (
    <Grid
      item
      classes={{
        root: classnames(classes.root, {
          [classes.disableGutter]: disableGutter,
        }),
      }}
    >
      {children}
    </Grid>
  );
};

Spacer.propTypes = {
  disableGutter: PropTypes.bool,
  children: PropTypes.node,
};

export default Spacer;
